import React from 'react';
import {
  Box,
  Button,
  Typography,
  useTheme,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';

const TableHeaderActions = ({
  table,
  handleButtonClick,
  selectedRows,
  handleClearSelection,
  handleSelectAll,
  data,
  message,
  messageColor,
  manufacturers,
  selectedManufacturer,
  setSelectedManufacturer,
}) => {
  const theme = useTheme();

  const baseButtonStyle = {
    fontSize: '1rem',
    fontWeight: 600,
    whiteSpace: 'pre',
    mr: 2,
  };

  const selectAllButtonStyle = {
    ...baseButtonStyle,
    backgroundColor: theme.palette.tsw.tertiary,
    '&:hover': {
      backgroundColor: theme.palette.tsw.tertiary[700],
    },
  };

  const clearSelectionButtonStyle = {
    ...baseButtonStyle,
    backgroundColor: theme.palette.tsw.secondary,
    '&:hover': {
      backgroundColor: theme.palette.tsw.secondary[700],
    },
  };

  return (
    <Box display='flex' gap={2} flexWrap='wrap' alignItems='center'>
      {data.length > 0 && (
        <>
          {selectedRows.length > 0 ? (
            <Button
              variant='contained'
              sx={clearSelectionButtonStyle}
              onClick={handleClearSelection}
            >
              <Typography
                sx={{ letterSpacing: '0.05em', fontWeight: 'bold', textTransform: 'none' }}
              >
                Clear Selection
              </Typography>
            </Button>
          ) : (
            <Button variant='contained' sx={selectAllButtonStyle} onClick={handleSelectAll}>
              <Typography
                sx={{ letterSpacing: '0.05em', fontWeight: 'bold', textTransform: 'none' }}
              >
                Select All
              </Typography>
            </Button>
          )}
        </>
      )}

      <FormControl sx={{ minWidth: 200 }}>
        <InputLabel id='manufacturer-filter-label'>Manufacturer</InputLabel>
        <Select
          labelId='manufacturer-filter-label'
          value={selectedManufacturer}
          label='Manufacturer'
          onChange={(e) => setSelectedManufacturer(e.target.value)}
        >
          <MenuItem value='All'>
            <em>All</em>
          </MenuItem>
          {manufacturers.map((man) => (
            <MenuItem key={man} value={man}>
              {man
                .toLowerCase()
                .split(' ')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ')}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default TableHeaderActions;
